import TableWithShowInfoColumn from "../../../Components/NewTable/TableWithShowInfoColumn";
import ListContainer from "../../../Components/UI/ListContainer/ListContainer";
import useHttpFetch from "../../../hooks/useHttpFetch";
import useListStateCustom from "../../../hooks/useListStateCustom";
import MultiLanTxt from "../../../Components/UI/MultiLanTxt/MultiLanTxt";
import { useNavigate } from "react-router-dom";
import classes from "./List.module.css";
import FormNetworkMarketerForm from "./Form";

const pageHeader = "Network Marketer List";
const routeEntity = "form-network-marketer";

const initialTableInfos = [
	{
		id: "sa121011l5",
		uniqueName: "StepStairCommission_id",
		label: "شناسه",
		show: false,
		order: 1,
		field: "id",
		neededAccesses: ["StepStairCommission_id"],
	},
	{
		id: "sapo11fisca4",
		uniqueName: "StepStairCommission_name",
		label: <MultiLanTxt tid="name" />,
		show: true,
		order: 2,
		field: "name",
		neededAccesses: ["StepStairCommission_name"],
	},
	{
		id: "sapop1fisca4",
		uniqueName: "StepStairCommission_code",
		label: <MultiLanTxt tid="code" />,
		show: true,
		order: 3,
		field: "code",
		neededAccesses: ["StepStairCommission_code"],
	},
	{
		id: "sapop1f2sca4",
		uniqueName: "StepStairCommission_directSale",
		label: <MultiLanTxt tid="directSale" />,
		show: true,
		order: 4,
		field: "directSale",
		neededAccesses: ["StepStairCommission_directSale"],
	},
	{
		id: "sapop1f25ca4",
		uniqueName: "StepStairCommission_superiorCode",
		label: <MultiLanTxt tid="superiorCode" />,
		show: true,
		order: 5,
		field: "superiorCode",
		neededAccesses: ["StepStairCommission_superiorCode"],
	},
	{
		id: "sapop1a25ca4",
		uniqueName: "StepStairCommission_superiorName",
		label: <MultiLanTxt tid="superiorName" />,
		show: true,
		order: 6,
		field: "superiorName",
		neededAccesses: ["StepStairCommission_superiorName"],
	},
];

const FormNetworkMarketerList = () => {
	const { isLoading, sendRequest } = useHttpFetch(false, "FNM");
	const navigate = useNavigate();
	const {
		datas,
		tableInfos,
		setTableInfos,
		clonedTableInfos,
		totalRecords,
		fieldAccessesAreLoading,
		actionStatus,
		setActionStatus,
		actionHandler,
		sendReqPerChange,
		enumOptions,
	} = useListStateCustom({
		usedListEntities: ["StepStairCommission"],
		initialTableInfos,
		urlMainEntity: "getStepStairCommission",
		routeEntity,
		sendRequest,
		customSearchStrInUrl: "mlmDataEntry",
		port: "9092",
	});

	return (
		<>
			<ListContainer>
				<TableWithShowInfoColumn
					datas={datas}
					editablelity={true}
					addEditRowComponent={FormNetworkMarketerForm}
					sendReqPerChange={sendReqPerChange}
					totalRecords={totalRecords}
					selectable={false}
					isLoading={isLoading}
					actionHandler={actionHandler}
					actionStatus={actionStatus}
					setActionStatus={setActionStatus}
					tableInfos={tableInfos}
					setTableInfos={setTableInfos}
					clonedTableInfos={clonedTableInfos}
					canAdd={true}
					canEdit={true}
					canDelete={true}
					fieldAccessesAreLoading={fieldAccessesAreLoading}
					enumOptions={enumOptions}
					pageHeader={pageHeader}
				/>
			</ListContainer>
			<span
				className={classes.addTableFeatureContainer}
				onClick={() => navigate("/step-stair-commission")}
			>
				جزئیات بیشتر
			</span>
		</>
	);
};

export default FormNetworkMarketerList;
